<template>
  <div class="step-error">
    <div class="error-icon">
      <img class="error-icon-flower" :src="flowerIcon" alt="" />
      <img class="error-icon-wizard" :src="wizardIcon" alt="" />
    </div>

    <h1 class="step-heading" dir="auto">משהו השתבש בדרך</h1>
    <p class="step-subtitle" dir="auto">{{ subtitleText }}</p>

    <div class="cta-area">
      <CtaButton
        :text="'לנסות שוב'"
        @click="$emit('retry')"
      />
      <button class="secondary-button" @click="$emit('contact-team')">
        לדבר עם הצוות
      </button>
    </div>
  </div>
</template>

<script>
import CtaButton from './CtaButton.vue';

const flowerIcon = require('@/pages/responsive-pages/non-authenticated/mortgage-refinance/assets/error-flower.svg');
const wizardIcon = require('@/pages/responsive-pages/non-authenticated/mortgage-refinance/assets/error-wizard.svg');

const SUBTITLES = {
  connection: 'לא הצלחנו לחבר את החשבון שלך. שננסה שוב?',
  generic: 'לא הצלחנו ליצור לך חשבון בדיקת משכנתא. שננסה שוב?',
};

export default {
  name: 'StepConnectionError',
  components: { CtaButton },
  props: {
    variant: {
      type: String,
      default: 'connection',
      validator(value) {
        return Object.keys(SUBTITLES).includes(value);
      },
    },
  },
  data() {
    return { flowerIcon, wizardIcon };
  },
  computed: {
    subtitleText() {
      return SUBTITLES[this.variant];
    },
  },
};
</script>

<style lang="scss" scoped>
.step-error {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 27px;
  align-items: center;
}

.error-icon {
  position: relative;
  width: 91px;
  height: 92px;
  margin-top: 80px;
  margin-bottom: 32px;
}

.error-icon-flower {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.error-icon-wizard {
  position: absolute;
  width: 42px;
  height: 42px;
  // Centered over the flower badge (91x92, icon 42x42 ⇒ ~24px / 25px insets).
  top: 21px;
  left: 24px;
}

.step-heading {
  font-family: 'SimplerProAlte', sans-serif;
  font-size: 33px;
  line-height: 1.07;
  font-weight: 900;
  font-style: italic;
  color: #205441;
  text-align: center;
  margin: 0 auto 12px;
  max-width: 298px;
}

.step-subtitle {
  font-family: 'SimplerPro', sans-serif;
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  color: #205441;
  text-align: center;
  margin: 0 auto;
  max-width: 281px;
}

.cta-area {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: auto;
  padding-bottom: 24px;
}

.secondary-button {
  width: 100%;
  height: 67px;
  background: #f9f7ed;
  border: 1px solid #4868ff;
  border-radius: 16px;
  box-shadow: 0px 4px 13.1px rgba(0, 0, 0, 0.09);
  font-family: 'SimplerPro', sans-serif;
  font-size: 20px;
  line-height: 26px;
  font-weight: 700;
  color: #4868ff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease, transform 0.15s ease;

  &:active {
    transform: scale(0.97);
  }
}
</style>
